document.addEventListener('DOMContentLoaded', function () {
  var headerMenus = document.querySelectorAll('header-menu');
  var desktopHover = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

  headerMenus.forEach(function (menu) {
    var details = menu.querySelector('details');
    if (!details) return;

    var closeTimeout;

    menu.addEventListener('mouseenter', function () {
      if (!desktopHover.matches) return;
      clearTimeout(closeTimeout);
      details.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', function () {
      if (!desktopHover.matches) return;
      closeTimeout = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });
  });
});